import getCheggEnv, { CheggEnv } from '../getCheggEnv';
import getMlpEnv, { MlpEnv } from '../getMlpEnv';
import isWindowDefined from '../isWindowDefined';
import getCheggTldFrom from './getCheggTldFrom';

/**
 * Returns the correct graphql gateway server based on hostname param. The
 * `bff` parameter is used for bff data sources e.g. 'me-web-bff'.
 * @param hostname e.g. "gateway.test.cheggnet.com.mx"
 * @param bff e.g. "me-web-bff"
 * @returns gateway url string
 * e.g. https://gateway.test.cheggnet.com.mx/one-graph/graphql or
 * https://gateway.test.cheggnet.com.mx/me-web-bff/graphql
 */
export default function getGqlUrl(hostname, bff) {
  var tld = (hostname || '').trim() // check for empty string
  ? getCheggTldFrom(hostname) || '.com' // fallback if hostname has invalid TLD
  : isWindowDefined ? getCheggTldFrom(window.location.hostname) : '.com';

  // getGqlUrl is used outside of chegg-web. Therefore additional checks will
  // need to be added to know if we are in a prod env. For example, the env var
  // used to check for prod in chegg-web is CHEGG_ENV. In MLP pages, the env
  // var used to check for prod is NODE_ENV.
  if (getCheggEnv() === CheggEnv.PROD ||
  // env check for chegg-web
  getMlpEnv() === MlpEnv.PROD // env check for MLP pages
  ) {
    return "https://gateway.chegg".concat(tld, "/").concat(bff || 'one-graph', "/graphql");
  }
  return "https://gateway.test.cheggnet".concat(tld, "/").concat(bff || 'one-graph', "/graphql");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/utils/dist/esm/urls/getGqlUrl.js
// module id = 2586
// module chunks = 11